import styled, { css } from "styled-components";
import {
  FaFacebookSquare,
  FaInstagramSquare,
  FaLinkedin,
  FaPhoneAlt,
  FaRegAddressBook,
  FaRegClock,
  FaRegHandshake,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { AiFillCloseCircle } from "react-icons/ai";
import { IoIosMail } from "react-icons/io";

export const flexCss = css`
  width: 100%;
  margin: auto;
  padding: 10px 20px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-flow: column;
`;

export const ContactData = styled.div`
  ${flexCss};
  height: 100%;
`;

export const ContactForm = styled.form`
  ${flexCss};
`;

export const FormError = styled.p`
  color: #f56565;
  font-size: 0.8rem;
`;

export const FormControl = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  flex-flow: column;
  margin: 10px 0;
  font-family: "Times New Roman", Times, serif;
`;

export const inputFeildCss = css`
  width: 100%;
  border-radius: 0.2rem;
  max-width: 500px;
  padding: 8px;
  outline: none;
  color: #666;
  font-size: 1rem;
  background: #fafafa;
  border: 1px solid #ccc;
  transition: all 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.primary};
  }
  &::placeholder {
    font-size: 20px;
    font-weight: 500;
    font-family: "Times New Roman", Times, serif;
  }
`;

export const Input = styled.input`
  ${inputFeildCss}
`;

export const Select = styled.select`
  ${inputFeildCss}
  font-size: 1rem;
  option {
    font-size: 1rem;
  }
`;

export const TextArea = styled.textarea`
  ${inputFeildCss}
  font-size: 0.9rem;
`;

export const SubmitButton = styled.button`
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  width: ${({ full }) => (full ? "100%" : "fit-content")};
  margin-top: 10px;
  padding: 0.5rem 0.75rem;
  font-weight: 600;
  border-radius: 0.25rem;
  border: none;
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  &:disabled {
    background: #dcdcdc;
    color: black;
  }
`;

export const ContactDetails = styled.div`
  ${flexCss};
  margin-bottom: 50px;
`;

export const ContactHead = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  @media screen and (max-width: 768px) {
    margin-left: -20px;
  }
`;

export const IconCss = css`
  font-size: 1.5rem;
  margin-right: 20px;
  color: #b1976b;
`;

export const StyledClose = styled(AiFillCloseCircle)`
  color: #b1976b;
  font-size: 2rem;
  position: absolute;
  z-index: 1000;
  right: -7px;
  top: -7px;
`;

export const StyledFaPhoneAlt = styled(FaPhoneAlt)`
  ${IconCss};
  font-size: 1.1rem;
`;

export const StyledFaMapMarkerAlt = styled(FaMapMarkerAlt)`
  ${IconCss};
  font-size: 1.5rem;
`;

export const StyledIoIosMail = styled(IoIosMail)`
  ${IconCss}
  font-size: 1.2rem;
`;

export const StyledContact = styled(FaRegAddressBook)`
  ${IconCss};
`;
export const StyledClock = styled(FaRegClock)`
  ${IconCss}
`;

export const StyledHandShake = styled(FaRegHandshake)`
  ${IconCss}
`;
export const ContactBody = styled.ul`
  list-style: ${({ noStyle }) => (noStyle ? "none" : "disc")};
  margin-left: 50px;
  @media screen and (max-width: 768px) {
    margin-left: 0px;
  }
`;
export const ContactItem = styled.li`
  display: flex;
  align-items: ${({ justify }) => (justify ? justify : "center")};
  font-size: 1.2rem;
  ${({ bold }) => bold && `font-weight: bold`}
`;

export const WorkingBody = styled.div`
  ${flexCss}
  flex-flow: row;
  margin-left: 30px;
`;
export const StyledInsta = styled(FaInstagramSquare)`
  ${IconCss}
  &:hover {
    transform: scale(1.1);
  }
`;
export const StyledFaceBook = styled(FaFacebookSquare)`
  ${IconCss}
  &:hover {
    transform: scale(1.1);
  }
`;

export const StyledLinkedIn = styled(FaLinkedin)`
  ${IconCss}
  &:hover {
    transform: scale(1.1);
  }
`;
